import React from "react";
import { auth } from "../../../firebase";
import { dateFormatter, getFormattedTime } from "../../../utils/Functions";

const Message = ({ message, scrollBottomRef }) => {
  const messageClass =
    message.from === auth.currentUser.uid
      ? "message_section_sent"
      : "message_section_received";

  return (
    <div className="message_container" ref={scrollBottomRef ? scrollBottomRef : null}>
      <div
        className={`message_section 
      ${messageClass}`}
      >
        <p className="message_section_text">{message.text}</p>
        <span className="message_section_time">{getFormattedTime(new Date(message?.timeStamp))}</span>
      </div>
    </div>
  );
};

export default Message;
